import { useParams } from 'next/navigation';

export const useOriginalSearchQuery = () => {
  const { searchquery } = useParams() ?? {};

  return typeof searchquery === 'string' ? decodeURIComponent(searchquery).replace(/\+/g, ' ') : '';
};
